import type { AlgoliaSearchService } from '@b2ag/search'
import type { IDiscountService } from '@b2ag/pricing/src/contexts/discount/discount.service'
import type { IOfferService } from '@b2ag/offers/src/services/offer.service'
import type ProductService from '@b2ag/product/src/services/product.service'
import type CartService from '@b2ag/cart/src/cart.service'
import type { ShoppingListApiClient } from '@b2ag/legacy-shared-shopping-list-sdk'

export * from './interfaces/store.interface'

/* -------- SERVICES for STORE ---------- */

interface ServicesForStore {
  searchService?: AlgoliaSearchService
  offerService?: IOfferService
  discountService?: IDiscountService
  productService?: ProductService
  cartService?: CartService
  shoppingListApiClient?: ShoppingListApiClient
}

let singl_servicesForStore = undefined as ServicesForStore | undefined

export function initServicesForStore(servicesForStore: ServicesForStore) {
  singl_servicesForStore = servicesForStore
}

export function getServicesForStore(): ServicesForStore {
  if (!singl_servicesForStore) throw new Error('Services for store were not initialized')
  return singl_servicesForStore
}

/* ---------- DEFAULT ---------- */

export default {}
